// extracted by mini-css-extract-plugin
module.exports = {"LinkLikeText":"_1rA3U","Monochrome":"ysaM1"};